module.exports = __webpack_public_path__ + "fonts/25f577c3-f32b-4fbf-b684-3e7c1a76d1ea.98f3b2d6.woff";